/**
 * Org × SKU task-admission overlay (#2222). Admin-only; the ops-api 403 is
 * the real gate.
 */
import type {
  DeleteOrgSkuTaskAdmissionOverrideResponse,
  ListOrgSkuTaskAdmissionOverridesResponse,
  PutOrgSkuTaskAdmissionOverrideRequest,
  PutOrgSkuTaskAdmissionOverrideResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

function base(orgId: string): string {
  return `/v1/ops/orgs/${encodeURIComponent(orgId)}/task-admission-overrides`;
}

export async function listOrgSkuTaskAdmissionOverrides(
  orgId: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListOrgSkuTaskAdmissionOverridesResponse> {
  return opsApiRequest<ListOrgSkuTaskAdmissionOverridesResponse>(base(orgId), { signal }, fetchImpl);
}

export async function putOrgSkuTaskAdmissionOverride(
  orgId: string,
  skuId: string,
  body: PutOrgSkuTaskAdmissionOverrideRequest,
  fetchImpl: typeof fetch,
): Promise<PutOrgSkuTaskAdmissionOverrideResponse> {
  return opsApiRequest<PutOrgSkuTaskAdmissionOverrideResponse>(
    `${base(orgId)}/${encodeURIComponent(skuId)}`,
    { method: 'PUT', body },
    fetchImpl,
  );
}

export async function deleteOrgSkuTaskAdmissionOverride(
  orgId: string,
  skuId: string,
  fetchImpl: typeof fetch,
): Promise<DeleteOrgSkuTaskAdmissionOverrideResponse> {
  return opsApiRequest<DeleteOrgSkuTaskAdmissionOverrideResponse>(
    `${base(orgId)}/${encodeURIComponent(skuId)}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
